import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMultiLoadTenderResults extends Layout {
    sourceSendAutoTender: DataSource;
    tableMultiSendLoadTender: Table;
}
